import DownloadNH from "../Common/DownloadNH";
import TravelInsights from "../Common/TravelInsights/TravelInsights";
import MainLayout from "../MainLayout";
import BlogSecTravelUpdate from "../Blog/BlogSecTravelUpdate/BlogSecTravelUpdate";
import CommonHeader from "@/Common/CommonHeader/CommonHeader";
import Breadcrumbs from "../Common/Breadcrumbs";

export default function BlogDestination({
  categorySlug = "",
  categoryInfo = null,
  initialCategoryData = null,
  country = "UAE",
}) {
  const bannerImage = initialCategoryData?.pageBannerImage;

  return (
    <div>
      <MainLayout hideHeader>
        <CommonHeader
          bgImage={bannerImage}
        />
        < Breadcrumbs
        />
        <TravelInsights
          isBlogPage={true}
          category={categorySlug}
          categoryInfo={categoryInfo}
          initialCategoryData={initialCategoryData}
          country={country}
        />
        <BlogSecTravelUpdate />
        <DownloadNH />
      </MainLayout>
    </div>
  );
}
